<template>
  <div class="ophthalmology-panel">
    <div class="card mb-4" v-if="imageAttributes.length > 0">
      <div class="card-header">
        <h5 class="card-title mb-0">Anotacoes em imagem</h5>
      </div>
      <div class="card-body">
        <InputAttendance
            v-for="attribute in imageAttributes"
            :key="attribute.id_medrec_attr"
            :attribute="attribute"
            :schedule="schedule"
            :disabled="disabled"
            @onChange="onAttributeChange"
        />
      </div>
    </div>

    <div class="card mb-4" v-if="gridAttributes.length > 0">
      <div class="card-header">
        <h5 class="card-title mb-0">Grades clinicas</h5>
      </div>
      <div class="card-body">
        <InputAttendance
            v-for="attribute in gridAttributes"
            :key="attribute.id_medrec_attr"
            :attribute="attribute"
            :schedule="schedule"
            :disabled="disabled"
            @onChange="onAttributeChange"
        />
      </div>
    </div>

    <div class="card mb-4" v-if="structuredAttributes.length > 0">
      <div class="card-header">
        <h5 class="card-title mb-0">Listas estruturadas</h5>
      </div>
      <div class="card-body">
        <InputAttendance
            v-for="attribute in structuredAttributes"
            :key="attribute.id_medrec_attr"
            :attribute="attribute"
            :schedule="schedule"
            :disabled="disabled"
            @onChange="onAttributeChange"
        />
      </div>
    </div>

    <div class="card" v-if="regularAttributes.length > 0">
      <div class="card-header">
        <h5 class="card-title mb-0">Observacoes</h5>
      </div>
      <div class="card-body">
        <InputAttendance
            v-for="attribute in regularAttributes"
            :key="attribute.id_medrec_attr"
            :attribute="attribute"
            :schedule="schedule"
            :disabled="disabled"
            @onChange="onAttributeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputAttendance from "./Input";

export default {
  name: "OphthalmologyPanel",
  components: {InputAttendance},
  emits: ['onChange'],
  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
    schedule: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageAttributes() {
      return this.attributes.filter((attribute) => attribute.type === 'image_annotation');
    },
    gridAttributes() {
      return this.attributes.filter((attribute) => attribute.type === 'grid');
    },
    structuredAttributes() {
      return this.attributes.filter((attribute) => attribute.type === 'structured_list');
    },
    regularAttributes() {
      return this.attributes.filter((attribute) => !['image_annotation', 'grid', 'structured_list'].includes(attribute.type));
    },
  },
  methods: {
    onAttributeChange(attribute) {
      this.$emit('onChange', attribute);
    },
  },
};
</script>
